import React from "react";
import { Card, Badge } from "react-bootstrap";
import "./PaymentSettings.css";

const PaymentSettings = ({
  userData,
  onSuspendAccountClick,
  onPackageChangeClick,
  userID,
  groups = [],
  coaches = [],
  onUserDataUpdate,
  isChangingPackage = false
}) => {

  const renderPackageDetails = () => {
    const paymentDetails = userData?.paymentDetails || {};
    const plan = paymentDetails.plan || "לא נבחר חבילה";
    const didPay = paymentDetails.didPay || false;
    const trialPeriodInMonths = paymentDetails.trialPeriodInMonths || 0;
    const userType = userData?.userType;

    // If userType is not 'manager', only show package type
    if (userType !== 'manager') {
      // If special payment plan is enabled, only show special plan
      if (paymentDetails?.specialPaymentPlan) {
        return (
          <div>
            <h4 className="mb-4">פרטי החבילה</h4>
            <div className="mb-3">
              <h5>סוג החבילה</h5>
              <span className="badge p-2" style={{ backgroundColor: "#9C27B0", color: "#FFFFFF" }}>
                תוכנית מיוחדת
              </span>
            </div>
          </div>
        );
      }

      // Convert plan name to Hebrew and get badge color
      const getPlanDetails = (plan) => {
        switch (plan.toLowerCase()) {
          case "gold":
            return {
              name: "תוכנית הזהב",
              color: "gold",
              style: { backgroundColor: "#FFD700", color: "#000000" },
            };
          case "silver":
            return {
              name: "תוכנית הכסף",
              color: "silver",
              style: { backgroundColor: "#C0C0C0", color: "#000000" },
            };
          case "bronze":
            return {
              name: "תוכנית הארד",
              color: "bronze",
              style: { backgroundColor: "#CD7F32", color: "#FFFFFF" },
            };
          default:
            return {
              name: "אין תוכנית",
              color: "info",
              style: { backgroundColor: "#17a2b8", color: "#FFFFFF" },
            };
        }
      };

      const planDetails = getPlanDetails(plan);

      return (
        <div>
          <h4 className="mb-4">פרטי החבילה</h4>
          <div className="mb-3">
            <h5>סוג החבילה</h5>
            <span className="badge p-2" style={planDetails.style}>
              {planDetails.name}
            </span>
          </div>
        </div>
      );
    }

    // Use userCreatedAt as תאריך רישום (registration date)
    const registrationDate = userData?.userCreatedAt
      ? new Date(userData.userCreatedAt.seconds * 1000).toLocaleString("he-IL")
      : "לא זמין";

    const lastPaymentDate = paymentDetails.lastPaymentDate
      ? new Date(paymentDetails.lastPaymentDate.seconds * 1000).toLocaleString("he-IL")
      : "לא בוצע תשלום";

    // Calculate trial end date and status
    const getTrialInfo = () => {
      if (!userData?.userCreatedAt || !trialPeriodInMonths) {
        return {
          endDate: null,
          isActive: false,
          hasExpired: false,
          formattedEndDate: null,
          daysRemaining: 0
        };
      }

      const registrationDate = new Date(userData.userCreatedAt.seconds * 1000);
      const trialEndDate = new Date(registrationDate);
      trialEndDate.setMonth(trialEndDate.getMonth() + trialPeriodInMonths);

      const now = new Date();
      const isActive = now < trialEndDate;
      const hasExpired = now >= trialEndDate;

      // Calculate days remaining
      const timeRemaining = trialEndDate - now;
      const daysRemaining = Math.ceil(timeRemaining / (1000 * 60 * 60 * 24));

      // Format date without time (only date)
      const formattedEndDate = trialEndDate.toLocaleDateString("he-IL", {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });

      return {
        endDate: trialEndDate,
        isActive,
        hasExpired,
        formattedEndDate,
        daysRemaining: Math.max(0, daysRemaining)
      };
    };

    const trialInfo = getTrialInfo();

    // Convert plan name to Hebrew and get badge color
    const getPlanDetails = (plan) => {
      switch (plan.toLowerCase()) {
        case "gold":
          return {
            name: "תוכנית הזהב",
            color: "gold",
            style: { backgroundColor: "#FFD700", color: "#000000" },
          };
        case "silver":
          return {
            name: "תוכנית הכסף",
            color: "silver",
            style: { backgroundColor: "#C0C0C0", color: "#000000" },
          };
        case "bronze":
          return {
            name: "תוכנית הארד",
            color: "bronze",
            style: { backgroundColor: "#CD7F32", color: "#FFFFFF" },
          };
        default:
          return {
            name: "אין תוכנית",
            color: "info",
            style: { backgroundColor: "#17a2b8", color: "#FFFFFF" },
          };
      }
    };

    // If special payment plan is enabled, only show special plan
    if (paymentDetails.specialPaymentPlan) {
      return (
        <div>
          <h4 className="mb-4">פרטי החבילה</h4>
          <div className="mb-3">
            <h5>סוג החבילה</h5>
            <span className="badge p-2" style={{ backgroundColor: "#9C27B0", color: "#FFFFFF" }}>
              תוכנית מיוחדת
            </span>
          </div>
        </div>
      );
    }

    const planDetails = getPlanDetails(plan);

    // Calculate if user is in trial period (keeping for backward compatibility)
    const isInTrial = () => trialInfo.isActive;

    return (
      <div>
        <h4 className="mb-4">פרטי החבילה</h4>

        <div className="mb-3">
          <h5>סוג החבילה</h5>
          <span className="badge p-2" style={planDetails.style}>
            {planDetails.name}
          </span>
        </div>

        <div className="mb-3">
          <h5>תאריך הקמת חשבון</h5>
          <p className="text-muted">{registrationDate}</p>
        </div>


        <div className="mb-3">
          <h5>אמצעי תשלום</h5>
          {(() => {
            const token = paymentDetails.token;
            const isTokenValid = token && token !== "";

            return (
              <span className={`badge p-2 ${isTokenValid ? 'bg-success' : 'bg-danger'}`}>
                {isTokenValid ? 'תקין' : 'טרם הוסדר'}
              </span>
            );
          })()}
        </div>

        <div className="mb-3">
          <h5>סטטוס תשלום</h5>
          {paymentDetails.userSuspended ? (
            <div>
              <span className="badge bg-warning p-2" style={{ color: "#000000" }}>
                מנוי מושהה
              </span>
              {paymentDetails.lastPaymentDate && (
                <div className="mt-2">
                  <p className="text-muted">
                    נותרו {(() => {
                      // Use the same calculation logic as usePaymentCheck.js
                      let paymentDate;
                      if (paymentDetails.lastPaymentDate.toDate) {
                        paymentDate = paymentDetails.lastPaymentDate.toDate();
                      } else if (paymentDetails.lastPaymentDate.seconds) {
                        paymentDate = new Date(paymentDetails.lastPaymentDate.seconds * 1000);
                      } else if (typeof paymentDetails.lastPaymentDate === 'string') {
                        paymentDate = new Date(paymentDetails.lastPaymentDate);
                      } else {
                        paymentDate = paymentDetails.lastPaymentDate;
                      }

                      // Validate the date
                      if (!paymentDate || isNaN(paymentDate.getTime())) {
                        return 0;
                      }

                      // Calculate grace period end date (30 days from last payment)
                      const gracePeriodEndDate = new Date(paymentDate);
                      gracePeriodEndDate.setDate(gracePeriodEndDate.getDate() + 30);

                      const now = new Date();
                      const timeRemaining = gracePeriodEndDate - now;
                      const daysRemaining = Math.ceil(timeRemaining / (1000 * 60 * 60 * 24));

                      return Math.max(0, daysRemaining);
                    })()} ימי שימוש
                  </p>
                </div>
              )}
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "20px" }}>
              <span className={`badge bg-${paymentDetails.lastPaymentDate ? "success" : "danger"} p-2`}>
                {paymentDetails.lastPaymentDate ? "בתשלום" : "טרם בוצע חיוב"}
              </span>
              {!paymentDetails.lastPaymentDate && isInTrial() && (
                <div >
                  <span
                    className="badge p-2"
                    style={{ backgroundColor: "#FFD700", color: "#000000" }}
                  >
                    בתקופת ניסיון
                  </span>
                </div>
              )}

              {/* Show billing failure status for scenarios D1 and D2 */}
              {paymentDetails?.lastBillingStatus === 'failure' && (
                <div>
                  <span className="badge bg-danger p-2">
                    כשל בחיוב
                  </span>
                  {paymentDetails?.lastBillingAttemptDate && (
                    <div className="mt-2">
                      <p className="text-muted small">
                        ניסיון חיוב אחרון: {(() => {
                          let billingDate;
                          if (paymentDetails.lastBillingAttemptDate.toDate) {
                            billingDate = paymentDetails.lastBillingAttemptDate.toDate();
                          } else if (paymentDetails.lastBillingAttemptDate.seconds) {
                            billingDate = new Date(paymentDetails.lastBillingAttemptDate.seconds * 1000);
                          } else if (typeof paymentDetails.lastBillingAttemptDate === 'string') {
                            billingDate = new Date(paymentDetails.lastBillingAttemptDate);
                          } else {
                            billingDate = paymentDetails.lastBillingAttemptDate;
                          }

                          if (!billingDate || isNaN(billingDate.getTime())) {
                            return "לא ידוע";
                          }

                          const now = new Date();
                          const timeSinceBilling = now - billingDate;
                          const daysSinceBilling = Math.ceil(timeSinceBilling / (1000 * 60 * 60 * 24));

                          if (daysSinceBilling <= 7) {
                            return `לפני ${daysSinceBilling} ימים (תקופת חסד)`;
                          } else {
                            return `לפני ${daysSinceBilling} ימים`;
                          }
                        })()}
                      </p>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>


        <div className="mb-3">
          <h5>תאריך תשלום אחרון</h5>
          <p className="text-muted">{lastPaymentDate}</p>
        </div>

        {trialPeriodInMonths > 0 && trialInfo.isActive && (
          <div className="mb-3">
            <h5>תקופת הניסיון</h5>
            <div>
              <p className="text-muted">
                תקופת הניסיון תסתיים ב- {trialInfo.formattedEndDate} (בעוד {trialInfo.daysRemaining} ימים)
              </p>
            </div>
          </div>
        )}

        {/* Account Management Section */}
        <div className="mb-3" style={{ borderTop: "1px solid #dee2e6", paddingTop: "20px" }}>
          <h5 className="mb-3">ניהול חשבון</h5>
          <div className="d-flex gap-2 flex-wrap">
            <button
              className="btn btn-outline-primary"
              onClick={onPackageChangeClick}
              disabled={isChangingPackage}
            >
              {isChangingPackage ? "מעדכן..." : "שינוי חבילת שימוש"}
            </button>
            <button
              className="btn btn-outline-danger"
              onClick={onSuspendAccountClick}
              disabled={isChangingPackage}
            >
              השעיית חשבון
            </button>
          </div>
        </div>
      </div>
    );
  };



  return (
    <Card className="payment-settings-card">
      <Card.Body>
        {renderPackageDetails()}
      </Card.Body>
    </Card>
  );
};

export default PaymentSettings;
